<onsip-header-main>
  <onsip-header-page-title>E911</onsip-header-page-title>
</onsip-header-main>

<main>
  <div class="mat-headline-4 e911-text e911-not-enabled">
    {{ "ONSIP_I18N.YOU_HAVENT_ENABLED_E911_YET" | translate }}
  </div>
  <div class="mat-body-2 e911-text e911-erl">
    {{
      "ONSIP_I18N.E911_EMERGENCY_RESPONSE_LOCATIONENABLES_USERS_TO_SPECIFY_THEIR_EXACT_LOCATION_SO_EMERGENCY_CALLS_CAN_BE_ROUTED_TO_THE_CORRECT_911_CENTERTHE_FOLLOWING_IS_REQUIRED_TO_ENABLE_E911"
        | translate
    }}
  </div>

  <div class="mat-body-2 e911-criteria">{{ "ONSIP_I18N.A_CREDIT_CARD_ON_FILE" | translate }}</div>
  <div class="mat-body-2 e911-criteria">
    {{ "ONSIP_I18N.NO_OUTSTANDING_BALANCE_ON_YOUR_PLAN" | translate }}
  </div>
  <div class="mat-body-2 e911-criteria">
    {{ "ONSIP_I18N.A_PSTN_CREDIT_BALANCE_ABOVE_000" | translate }}
  </div>

  <button
    mat-flat-button
    color="primary"
    [routerLink]="views.ADMIN_ACCOUNT_SETTINGS_CREDIT_CARD"
    class="update-billing-info"
  >
    {{ "ONSIP_I18N.UPDATE_YOUR_BILLING_INFO" | translate }}
  </button>

  <div class="mat-body-2 e911-text">
    {{
      "ONSIP_I18N.REQUIRES_CC__PSTN_BALANCE_FREE_TO_ENABLE__USERBASED_COST_OF_180_PER_MONTH_FOR_EACH_USER_ADDED_TO_A_LOCATION"
        | translate
    }}
  </div>
</main>
